export const colorMapping = {
  keynote: '#2088FD',
  'Device AI': '#FFCA0F',
  SmartThings: '#2088FD',
  'Responsible AI': '#FFAE34',
  'Advanced Tech': '#1259AA',
  'Enterprise & Ecosystem': '#96D452',
};
